import CustomButton from "components/Atoms/CustomButton"
import Divider from "components/Atoms/Divider"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import FormController from "components/Molecules/FormController"
import { ESTIMATED_DELIVERY_DAYS } from "data/static.items"
import React from "react"
import classNames from "utils/classNames"
import styles from "./dc.module.scss"
import useDCStore from "./dc.store"
import FormLayout from "./FormLayout"
const DeliveryCharges = ({ disabled = false }) => {
  const { onAdd, onRemove, state, onChange } = useDCStore(store => ({
    onAdd: store.addListItem,
    onRemove: store.removeListItem,
    state: store.state.deliveryCharges,
    onChange: store.setData("deliveryCharges"),
  }))

  const deliveryCosts = state?.deliveryCosts
  return (
    <FormController source={state} onChange={onChange}>
      <FormLayout
        className={classNames(styles.grid, styles.grid_cols_4)}
        title="Delivery Charges"
        onAdd={() => {
          onAdd(`deliveryCharges.deliveryCosts`, {
            costRange: [],
          })
        }}
      >
        {deliveryCosts?.map((_: any, idx: number) => {
          return (
            <React.Fragment key={idx}>
              <StringInput
                leftIcon="rupee"
                type="number"
                big={false}
                path={`deliveryCosts.${idx}.costRange.0`}
                label={
                  <span>
                    Order Price{" "}
                    <span className="vt-highlight vt-dark">Greater Than</span>
                  </span>
                }
              />
              <StringInput
                leftIcon="rupee"
                type="number"
                big={false}
                path={`deliveryCosts.${idx}.costRange.1`}
                label={
                  <span>
                    Order Price{" "}
                    <span className="vt-highlight vt-dark">Lower Than</span>
                  </span>
                }
              />
              <StringInput
                leftIcon="rupee"
                type="number"
                big={false}
                path={`deliveryCosts.${idx}.deliveryCost`}
                label="Shipping Rate"
              />
              <CustomButton
                className={styles.trash}
                disabled={disabled}
                onClick={e => onRemove(`deliveryCharges.deliveryCosts`, idx)}
                minimal
                intent="danger"
                icon="trash"
              />
            </React.Fragment>
          )
        })}
      </FormLayout>
      {deliveryCosts?.length ? <Divider className="mb-0" /> : null}
      <FormLayout
        className={classNames(styles.grid, styles.grid_cols_4)}
        title="Additional Information"
      >
        <StringInput
          min={0}
          helperText="Minimum amount a user can order"
          leftIcon="rupee"
          big={false}
          label="Mimum Cart Value"
          type="number"
          path="minCartValue"
        />
        <StaticSelector
          items={ESTIMATED_DELIVERY_DAYS}
          big={false}
          label="Estimated Delivery Days"
          path="estimatedDelta"
        />
      </FormLayout>
    </FormController>
  )
}

export default DeliveryCharges
